// Auto generated file, do not manually modify!
// com.hotpads.listingdatamodeltypes.enums.listingcostandfee.FeeCalculationType

export enum FeeCalculationType {
  FLAT_FEE = 'FLAT_FEE',
  MULTIPLIER_OF_RENT = 'MULTIPLIER_OF_RENT',
  PERCENTAGE_OF_RENT = 'PERCENTAGE_OF_RENT',
  PERCENTAGE_OF_SECURITY_DEPOSIT = 'PERCENTAGE_OF_SECURITY_DEPOSIT',
  PER_ITEM_FIXED = 'PER_ITEM_FIXED',
  PER_ITEM_PERCENTAGE_OF_RENT = 'PER_ITEM_PERCENTAGE_OF_RENT',
  RANGE = 'RANGE',
  STEPPED = 'STEPPED',
  VARIABLE_USAGE_BASED = 'VARIABLE_USAGE_BASED',
}

export const FeeCalculationType_values = [
  FeeCalculationType.FLAT_FEE,
  FeeCalculationType.MULTIPLIER_OF_RENT,
  FeeCalculationType.PERCENTAGE_OF_RENT,
  FeeCalculationType.PERCENTAGE_OF_SECURITY_DEPOSIT,
  FeeCalculationType.PER_ITEM_FIXED,
  FeeCalculationType.PER_ITEM_PERCENTAGE_OF_RENT,
  FeeCalculationType.RANGE,
  FeeCalculationType.STEPPED,
  FeeCalculationType.VARIABLE_USAGE_BASED,
] as const;
